import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { useTranslation } from '../hooks/useTranslation';
import { useTheme } from '../hooks/useTheme';
import { Mail, Globe, AlertTriangle } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '../components/ui/alert';

export const ImprintPage = () => {
  const { t, language, changeLanguage } = useTranslation();
  const { theme, toggleTheme } = useTheme();

  return (
    <div className="min-h-screen flex flex-col bg-background" data-testid="imprint-page">
      <Header
        t={t}
        theme={theme}
        toggleTheme={toggleTheme}
        language={language}
        changeLanguage={changeLanguage}
      />

      <main className="flex-1 container mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="max-w-3xl mx-auto space-y-8">
          {/* Title */}
          <div className="text-center space-y-2">
            <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight">
              {t('imprint_title')}
            </h1>
          </div>

          {/* Legal Information */}
          <section className="space-y-4">
            <h2 className="font-heading font-semibold text-2xl flex items-center gap-2">
              <Globe className="h-6 w-6" />
              {t('imprint_legal')}
            </h2>
            <div className="p-6 border border-border rounded-sm bg-card">
              <p className="font-semibold text-foreground">
                WordRiver
              </p>
              <p className="text-muted-foreground leading-relaxed mt-2">
                {t('imprint_legal_text')}
              </p>
            </div>
          </section>

          {/* Contact */}
          <section className="space-y-4">
            <h2 className="font-heading font-semibold text-2xl flex items-center gap-2">
              <Mail className="h-6 w-6" />
              {t('imprint_contact')}
            </h2>
            <div className="p-6 border border-border rounded-sm bg-card">
              <p className="text-muted-foreground mb-3">
                {t('imprint_contact_text')}
              </p>
              <a 
                href="mailto:arno.heimgartner@uni-graz.at" 
                className="inline-flex items-center gap-2 text-foreground hover:underline font-medium"
                data-testid="contact-email"
              >
                <Mail className="h-4 w-4" />
                arno.heimgartner@uni-graz.at
              </a>
            </div>
          </section>

          {/* Disclaimer */}
          <section className="space-y-4">
            <h2 className="font-heading font-semibold text-2xl flex items-center gap-2">
              <AlertTriangle className="h-6 w-6" />
              {t('imprint_disclaimer')}
            </h2>
            <Alert>
              <AlertTriangle className="h-4 w-4" />
              <AlertTitle>{t('imprint_important_notice')}</AlertTitle>
              <AlertDescription>
                {t('imprint_disclaimer_text')}
              </AlertDescription>
            </Alert>
          </section>

          {/* Privacy */}
          <section className="space-y-4">
            <h2 className="font-heading font-semibold text-2xl">
              {t('footer_privacy')}
            </h2>
            <div className="p-6 border border-border rounded-sm bg-card space-y-4">
              <p className="text-muted-foreground leading-relaxed">
                <strong>{t('imprint_privacy_data')}:</strong> {t('imprint_privacy_data_text')}
              </p>
              <p className="text-muted-foreground leading-relaxed">
                <strong>{t('imprint_privacy_storage')}:</strong> {t('imprint_privacy_storage_text')}
              </p>
              <p className="text-muted-foreground leading-relaxed">
                <strong>{t('imprint_privacy_donations')}:</strong> {t('imprint_privacy_donations_text')}
              </p>
            </div>
          </section>
        </div>
      </main>

      <Footer t={t} />
    </div>
  );
};
